// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\core\Database\Enums\DateField
// Generated on: 2025-10-12 12:23:50

export enum DateField {
  CREATED_AT = 'created_at',
  UPDATED_AT = 'updated_at',
}

export const DateFieldCases = ["created_at", "updated_at"] as const;

